import Cancel from 'axios/lib/cancel/Cancel'

export const isCancelled = (err) => {
  if (err.error instanceof Cancel) {
    return true
  }
  return false
}
